import { Select } from '@/lib/base/forms/select/select';
import { useFieldTypes } from '@/lib/crm/hooks/useFieldTypes';
import { getPropertyTypeIconComponent } from '@/lib/crm/utils/icons/PropertyTypeIcon';

import { SelectInputError, SelectInputLoading } from './SelectInputStates';
import type { PropertyInputProps } from './TextInput';

export const FieldTypeSelectInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  inputRef,
  placeholder,
  size = 'sm',
}) => {
  const { data, isLoading, error } = useFieldTypes();

  const items = (data ?? []).map(ft => ({
    id: ft.field_type_name,
    label: ft.label,
  }));

  const Icon = getPropertyTypeIconComponent(propertyType);

  if (isLoading) {
    return <SelectInputLoading />;
  }

  if (error) {
    return <SelectInputError error={error} />;
  }

  return (
    <Select.ComboBox
      placeholder={placeholder || `Select ${propertyType.label.toLowerCase()}`}
      size={size}
      items={items}
      selectedKey={value !== null && value !== undefined ? String(value) : null}
      onSelectionChange={key =>
        onChange(key !== null && key !== undefined ? String(key) : null)
      }
      isDisabled={disabled}
      shortcut={false}
      aria-label={propertyType.label}
      icon={Icon}
      ref={inputRef}
    >
      {item => <Select.Item id={item.id}>{item.label}</Select.Item>}
    </Select.ComboBox>
  );
};
